import { ActiveTabGuard } from 'components/active-tab-guard';
import { WithConnectedDashboard } from 'components/dashboard/Dashboard.connected';
import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import { workspaceTabCreatedThunk } from 'state/workspaces/workspace.thunks';

import { StaticQuotesTab } from './StaticQuotesTab';

export const StaticQuotesWorkspace: FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();
  const onAddNewTab = useCallback(() => {
    dispatch(workspaceTabCreatedThunk('static', 'quote'));
  }, [dispatch]);

  return (
    <ConnectedTabsWorkspace workspace="static" onAddNewTab={onAddNewTab} paddingClassName="ps-2">
      {(tab, isDashboardActive, onHideDashboard) =>
        tab?.id && (
          <WithConnectedDashboard isActive={isDashboardActive} onHide={onHideDashboard}>
            <ActiveTabGuard workspace="static">
              <StaticQuotesTab tabId={tab.id} />
            </ActiveTabGuard>
          </WithConnectedDashboard>
        )
      }
    </ConnectedTabsWorkspace>
  );
};

StaticQuotesWorkspace.displayName = 'StaticQuotesWorkspace';
